// The swap endpoint answers with { ok: false, error: 'code' } - a single string,
// not the { errors: [...] } array the rest of the drawer's endpoints return - so
// a reader looking for the array finds nothing and every refusal reads as the
// same transient "try again", including the ones that will never come good.
const REASONS = {
  invalid_area_code: 'That is not an area code. They are three digits and never start with 0 or 1.',
  number_added_by_team: 'Your number is set up by our team. Message us and we will sort it out.',
  area_code_unavailable: 'That area code has no numbers free right now. Try another one.',
  not_self_serve: 'This number cannot be changed from here. Message us and we will sort it out.',
  provisioning_failed: 'We could not reach our number provider just now. Try again in a moment.'
}

export function areaCodeErrorMessage(error, fallback) {
  const data = error?.response?.data
  const listed = data?.errors
  if (Array.isArray(listed) && listed.length) return listed.join('. ')

  return REASONS[data?.error] || fallback
}

// US area codes are three digits and never lead with 0 or 1, so a Check on one
// is a round trip we already know the answer to.
export const AREA_CODE_PATTERN = /^[2-9]\d{2}$/

export function isCheckableAreaCode(value) {
  return AREA_CODE_PATTERN.test(String(value ?? '').trim())
}
